module.exports = __webpack_public_path__ + "img/sistecredito.412ff186.png";